
import Vue from 'vue'
import axios, { AxiosError } from 'axios'
import { Component } from 'vue-property-decorator'
import { VForm } from '../../global/vuetify.types'
import InvalidToken from '../components/InvalidResetTokenCard.vue'
import { authAxios } from '../utils'

@Component({
  components: { InvalidToken }
})
export default class ActivateAccountPage extends Vue {
  private formValid = false

  private tokenInvalid = false

  private success = false

  private reason: string | null = null

  private error: string | null = null

  private password: string | null = null

  private confirmPassword: string | null = null

  get token() {
    return this.$route.params.token
  }

  get passwordRules() {
    return [
      (v: string) => !!v || 'Please enter a password',
      (v: string) => (v && v.length >= 7) || 'Password must be at least 7 characters'
    ]
  }

  get confirmPasswordRules() {
    return [
      (v: string) => !!v || 'Please confirm password',
      (v: string) => v === this.password || 'Passwords must match'
    ]
  }

  get form() {
    return this.$refs.form as VForm
  }

  mounted() {
    this.checkToken()
  }

  async checkToken() {
    try {
      await authAxios.post(`/activate/${this.token}/validate`)
    } catch (error) {
      this.tokenInvalid = true
      this.reason = error.response.data.reason
    }
  }

  async submit() {
    if (this.form.validate()) {
      const data = {
        password: this.password,
        token: this.token
      }

      try {
        await authAxios.post('/activate', data)
        this.success = true
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError<{ reason: string; message?: string }>
          const responseStatus = err.response?.status || 0
          if (responseStatus >= 400 && responseStatus < 500) {
            if (err.response?.data.reason === 'invalid') {
              this.error = 'The provided token is invalid'
            } else {
              this.error = err.response?.data.message || null
            }
          } else if (responseStatus === 500) {
            this.error = 'There was an error activating your account, please try again later'
          } else {
            throw error
          }
        } else {
          throw error
        }
      }
    }
  }
}
